// modules
import { useCallback, useEffect, useRef } from 'react'
import { Voice } from '@weblite/voice-recorder'
// helpers
import { RecordedVoice } from '@weblite-wapps/protocol'
import { RecorderStatus } from '../../../send-field.type'
import { VoiceRecorder } from '$logic/voice-recorder/voice-recorder'

export const useReactRecorder = ({
  state,
  setRecorderState,
  setRecorderVoice,
}: {
  state: RecorderStatus
  setRecorderState: (newState: RecorderStatus) => unknown
  setRecorderVoice: (voice: RecordedVoice) => unknown
}) => {
  const recording = state === 'STARTING' || state === 'RECORD'
  const restarting = state === 'RESTARTING'

  const MIN_DURATION = 1000

  const isAlreadyRecording = useRef<boolean>(false)

  const onRecordStart = useCallback(() => {
    setRecorderState('RECORD')
  }, [])

  const onRecordStop = useCallback(async (voice: Voice) => {
    if (voice.duration < MIN_DURATION) setRecorderState('IDLE')
    else {
      try {
        const wave = await VoiceRecorder.getRecordedVoiceWave(voice)
        setRecorderVoice({ ...voice, wave })
        setRecorderState('PREVIEW')
      } catch (e) {
        // handle error
      }
    }
  }, []) // TODO: check this dependency on voice upload

  useEffect(() => {
    if (!recording) {
      VoiceRecorder.stop()
        .then(v => {
          if (restarting) {
            setRecorderState('STARTING')
          } else {
            isAlreadyRecording.current = false
            onRecordStop(v)
          }
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when stopping recording:', error),
        )
    } else if (recording) {
      VoiceRecorder.start()
        .then(() => {
          onRecordStart()
          isAlreadyRecording.current = true
        })
        .catch((error: any) =>
          // eslint-disable-next-line no-console
          console.log('Error occurred when starting recording:', error),
        )
    }
  }, [recording, restarting])

  useEffect(() => {
    return () => {
      if (isAlreadyRecording.current) {
        VoiceRecorder.stop()
      }
    }
  }, [])

  return {
    isPending:
      state === 'STARTING' || state === 'WAITING' || state === 'RESTARTING',
  }
}
